// React things
import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";

// Rive things
import { useRive, Layout, Fit, Alignment, EventType } from "@rive-app/react-canvas";

// Stores
import useApplicationSettings from '../../Store/ApplicationSettings.js';

// Components
import RiveArtboard from '../../ComponentsWrappers/RiveArtboard.jsx';

export default function TimeFilter(props){

    const navigate = useNavigate()

    const localization = useApplicationSettings((state)=> state.localization)

    function setupSetting(rive){
        if (rive){
            rive.on(EventType.RiveEvent, (e)=>{
                switch(e.data.name){    
                    case "MonthClick":
                        // navigate('/lotterys')
                        props.setLeaderBoardTimeFilter('month')
                        break;
                    case "AllTimeClick":
                        props.setLeaderBoardTimeFilter('alltime')
                        break;
                }
            })
        }
    }  

    return (
        <RiveArtboard artboard={localization["rive_TimeFilter 2"]} stateMachines={'State Machine 1'} setupSetting={setupSetting} setLoading={props.setLoading}/>
    )
    
}